import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosPublic from "../../api/axiosConfig";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axiosPublic.post("/admin/auth/login", {
        username,
        password,
      });

      localStorage.setItem("adminToken", response.data.token);
      navigate("/admin-panel");
    } catch (err) {
      setError(
        err.response?.status === 401
          ? "Invalid username or password"
          : "Server error, try later"
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-notificationList p-4">
      <h2 className="text-3xl font-bold mb-6 text-white">Admin Login</h2>
      <form
        onSubmit={handleLogin}
        className="w-full max-w-sm bg-white p-6 rounded-lg shadow-md"
      >
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          className={`w-full mb-4 p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className={`w-full mb-4 p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            error ? "border-red-500" : "border-gray-300"
          }`}
        />
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700 transition"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
